import styled, { css } from 'styled-components';
import { withFancyHorizontalScrollbar } from '../../../constants/styleUtils/styleUtils';

export const Tabs = styled.div`
	display: flex;
	align-items: stretch;
	height: 5.2rem;
	border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
	overflow-y: hidden;
	overflow-x: auto;
	/* ios specific: */
	@supports (-webkit-overflow-scrolling: touch) {
		overflow-x: scroll;
	}
	${withFancyHorizontalScrollbar};
`;

export const Tab = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 0 0 auto;
	margin-bottom: -1px;
	padding: 0 2rem;
	color: ${({ theme }) => theme.colors.black};
	border-bottom: 2px solid transparent;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	transition: border-color 150ms;
	cursor: pointer;
	background-color: transparent;
	font-size: inherit;
	letter-spacing: inherit;

	&:hover {
		border-color: ${({ theme }) => theme.colors.borderDark};
	}

	&:first-child {
		padding-left: 0;
	}

	${({ active }) =>
		active &&
		css`
			border-color: ${({ theme }) => theme.colors.primary};

			&:hover {
				border-color: ${({ theme }) => theme.colors.primaryDark};
			}
		`};
`;
